import axios from 'axios';
import { getApiEndpoint } from './utilities';

export default {



    getAddressBooks(emailAddress, cb) {

        axios.get(getApiEndpoint() + 'api/marketing/address-books?emailAddress=' + emailAddress)
            .then(response => {
                cb(response.data);
            });
    },
    subscribe(payload, cb) {

        axios.post(getApiEndpoint() + 'api/marketing/subscribe', payload)
            .then(response => {
                cb(response.data);
            });
    },
    unsubscribe(payload, cb) {

        axios.post(getApiEndpoint() + 'api/marketing/unsubscribe', payload)
            .then(response => {
                cb(response.data);
            });
    }
}